import PropTypes from "prop-types";

import { ListItemLoader } from "@features/ui";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { EmptyArray } from "@lib/app.helpers";
import { PathwayListItem } from "./pathway.list-item";

export const PathwaysList = ({
  careerPlans,
  isLoading,
  isError,
  onRetry,
  onDownloadClicked,
}) => {
  if (isLoading) {
    return EmptyArray(5).map((_, index) => <ListItemLoader key={index} />);
  }

  if (isError) {
    return (
      <div className="pathways-list-retry">
        <button onClick={onRetry}>
          <FontAwesomeIcon icon={["fasr", "rotate-right"]} />
          <span>Retry</span>
        </button>
      </div>
    );
  }

  if (careerPlans?.length === 0 && !isLoading) {
    return (
      <div className="no-pathways">
        You have not set any career pathways yet.
      </div>
    );
  }

  return (
    <div className="pathways-list">
      {careerPlans?.map((careerPlan) => (
        <PathwayListItem
          key={careerPlan.id}
          careerPlan={careerPlan}
          onDownloadClicked={onDownloadClicked}
        />
      ))}
    </div>
  );
};

PathwaysList.propTypes = {
  careerPlans: PropTypes.array,
  isLoading: PropTypes.bool,
  isError: PropTypes.bool,
  onRetry: PropTypes.func,
  onDownloadClicked: PropTypes.func,
};
